// Navbar.jsx
import React from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-scroll';

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <nav className="bg-[#00000087] shadow-lg fixed w-full z-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-20">
          <div className="flex-column items-center my-2">
            <div className=''>
              <span className="text-lg md:text-2xl font-bold text-white">ever</span>
              <span className="text-lg md:text-2xl font-bold text-green-400">green</span>
            </div>
            <div className='flex-row'>
              <div className="text-lg md:text-2xl font-bold text-white">growth partners</div>
            </div>
           
          </div>

          <div className="hidden md:flex items-center space-x-8">
           
             <Link className="text-gray-100 hover:text-green-400 text-lg" to="about" smooth={true} duration={500}>
             About Us
              </Link>
             <Link className="text-gray-100 hover:text-green-400 text-lg" to="services" smooth={true} duration={500}>
             Our Services
              </Link>
             <Link className="text-gray-100 hover:text-green-400 text-lg" to="founder" smooth={true} duration={500}>
             About the Founder
              </Link>
             <Link className="text-gray-100 hover:text-green-400 text-lg" to="contact" smooth={true} duration={500}>
             Contact Us
              </Link>
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-green-400"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-[#00000090] ">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-[#00000090] items-end">
            <a href="#about" className="flex px-3 py-2 text-gray-300 hover:text-green-400" onClick={() => setIsMenuOpen(!isMenuOpen)}>About Us</a>
            <a href="#services" className="flex px-3 py-2 text-gray-300 hover:text-green-400" onClick={() => setIsMenuOpen(!isMenuOpen)}>Our Services</a>
            <a href="#founder" className="flex px-3 py-2 text-gray-300 hover:text-green-400" onClick={() => setIsMenuOpen(!isMenuOpen)}>About the Founder</a>
            <a href="#contact" className="flex px-3 py-2 text-gray-300 hover:text-green-400" onClick={() => setIsMenuOpen(!isMenuOpen)}>Contact Us</a>
          </div>
        </div>
      )}
    </nav>
  );
};